import { render, staticRenderFns } from "./veSbzcZcRetireEdit.vue?vue&type=template&id=54c3f09a&scoped=true"
import script from "./veSbzcZcRetireEdit.vue?vue&type=script&lang=js"
export * from "./veSbzcZcRetireEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54c3f09a",
  null
  
)

export default component.exports